export const inspectTable = [
  {
    content: "안전보건계획 이사회 보고 및 승인 (법 제14조)",
    isChecked: "",
  },
  {
    content: "안전보건관리책임자, 안전보건총괄책임자 선임 또는 지정, 업무수행 (법 제15조, 제62조)",
    isChecked: "",
  },
  {
    content: "관리감독자 업무수행 (법 제16조)",
    isChecked: "",
  },
  {
    content: "안전관리자, 보건관리자, 안전보건관리담당자 선임 및 업무수행 (법 제17조, 제18조, 제19조)",
    isChecked: "",
  },
  {
    content: "산업안전보건위원회 설치 및 운영 (법 제24조)",
    isChecked: "",
  },
  {
    content: "안전보건관리규정 작성, 변경 및 준수 (법 제25조~제28조)",
    isChecked: "",
  },
];
